export default "/_next/static/chunks/fonts/Cormorant-Regular-latin-a082853790f6533994a767d93c5eb866.woff2";